import { NgModule } from '@angular/core';
import { InactivityListenerDirective } from './inactivity-listener.directive';
import { InactivityListenerComponent } from './inactivity-listener.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [InactivityListenerDirective, InactivityListenerComponent],
  exports: [InactivityListenerDirective],
  imports: [MatDialogModule, CommonModule, TranslateModule],
})
export class InactivityListenerModule {}
